import ContactsList from "@/components/contacts/ContactsList";
import DashboardLayout from "@/components/dashboard/DashboardLayout";

export default function ContactsPage() {
  return (
    <DashboardLayout
      activePath="/dashboard/contacts"
      title="Contacts"
      breadcrumbs={[{ label: "Contacts" }]}
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        <ContactsList />
      </div>
    </DashboardLayout>
  );
}
